// -----京东系
import axios from './axios.js'
import qs from 'qs'

//匹配单元的计划
export const queryGroupList = params => {
    return axios.post(`/express/queryGroupList`, params)
};

//修改用户单元状态
export const updateGroupStatusById = params => {
    return axios.post(`/express/updateGroupStatusById`, params)
};

//根据skuId匹配sku信息
export const querySkuInfoBySkuIds = params => {
    return axios.post(`/addGoods/querySkuInfoBySkuIds`, params)
};

//计划列表
export const queryCampaignInfo = params => {
    return axios.get(`/addGoods/queryCampaignInfo`, {params})
};

// 获取关键词
export const queryKuaiCheKeywordList = params => {
    return axios.get(`/addGoods/queryKuaiCheKeywordList`, {params})
};

//  查字典
export const JdKuaiCheKeywordType = params => {
    return axios.get(`/dict/queryDictInfos`, {params})
};

// 获取人群
export const queryKuaiCheCrowdList = params => {
    return axios.get(`/addGoods/queryKuaiCheCrowdList`, {params})
};
// 创建快车单元
export const createKuaiCheGroup = params => {
    return axios.post(`/addGoods/createKuaiCheGroup`, params)
};

// 查询计划相关信息
export const jdQueryCampaignInfo = params => {
    return axios.get(`/jd/deleteKeyword/queryCampaignInfo`, {params})
};

//查询单元相关信息
export const jdQueryGroupInfos = params => {
    return axios.get(`/jd/deleteKeyword/queryGroupInfos`, {params})
};

//快车关键词列表，目前只限于已在投放的关键词
export const jdQueryKeywordInfos = params => {
    return axios.get(`/jd/deleteKeyword/queryKeywordInfos`, {params})
};

// 查询关键词日志记录
export const queryJdKeywordLogList = params => {
    return axios.post(`/jd/deleteKeyword/queryJdKeywordLogList`, params)
};

//批量修改关键词价格
export const batchUpdPriceKeyword = params => {
    return axios.post(`/jd/deleteKeyword/batchUpdPriceKeyword`, params)
};

//查询关键词日志所有操作人
export const queryJdKeywordLogOperationList = params => {
    return axios.get(`/jd/deleteKeyword/queryJdKeywordLogOperationList`, { params })
};

//批量删除关键词
export const batchDeleteKeyword = params => {
    return axios.post(`/jd/deleteKeyword/batchDeleteKeyword`, params)
};

// 快车关键词列表，目前只限于已在投放的关键词
export const queryKeywordByAddKeyword = params => {
    return axios.get(`/jd/addKeyword/queryKeywordByAddKeyword`, {params})
};

// JD关键词绑定关键词（上词）
export const groupBindKeywordByAddKeyword = params => {
    return axios.post(`/jd/addKeyword/groupBindKeywordByAddKeyword`, params)
};

// 查询所有快车计划
export const queryCampaignByAddKeyword = params => {
    return axios.get(`/jd/addKeyword/queryCampaignByAddKeyword`, {params})
};
// 查询单元（计划ID必填）
export const queryGroupByAddKeyword = params => {
    return axios.get(`/jd/addKeyword/queryGroupByAddKeyword`, {params})
};

// 根据SKU匹配单元以及计划
export const matchSkuIdList = params => {
    return axios.post(`/express/matchSkuIdList`, params)
};


// WEBPACK FOOTER //
// ./src/api/jd.js